import { render, staticRenderFns } from "./ClienteEnderecoForm.vue?vue&type=template&id=d62687f4&"
import script from "./ClienteEnderecoForm.vue?vue&type=script&lang=js&"
export * from "./ClienteEnderecoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports